/* index.tsx generated by @compiled/babel-plugin v0.37.1 */
import { ax, ix } from "@compiled/react/runtime";
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._19pkv77o%7Bmargin-top%3Avar(--ds-space-025%2C2px)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._kqswh2mm%7Bposition%3Arelative%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1nmz1hna%7Bword-break%3Abreak-word%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1i4qfg65%7Boverflow-wrap%3Aanywhere%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1mouze3t%7Bmargin-block%3Avar(--ds-space-0%2C0)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._4cvr1y6m%7Balign-items%3Aflex-start%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1bah1yb4%7Bjustify-content%3Aspace-between%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._4cvr1h6o%7Balign-items%3Acenter%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1e0c1txw%7Bdisplay%3Aflex%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._zulp1b66%7Bgap%3Avar(--ds-space-050%2C4px)%7D");
import React from 'react';
import { useIntl } from 'react-intl';
import Heading from '@atlaskit/heading';
import Link from '@atlaskit/link';
import { AtlassianIcon, RovoIcon } from '@atlaskit/logo';
import { fg } from '@atlaskit/platform-feature-flags';
import { Box, Inline, Stack } from '@atlaskit/primitives/compiled';
import Skeleton from '@atlaskit/skeleton';
import Tooltip from '@atlaskit/tooltip';
import type { AgentCreatorType } from '../../common/types';
import { HiddenIcon } from '../../common/ui/hidden-icon';
import { StarIconButton } from '../../common/ui/star-icon-button';
import { isForgeAgentByCreatorType } from '../../common/utils/is-forge-agent';
import { messages } from './messages';
const styles = {
  clickableItem: "_zulp1b66 _1e0c1txw _4cvr1h6o",
  rovoIconWrapper: "_1e0c1txw",
  name: "_1bah1yb4 _4cvr1y6m",
  description: "_1mouze3t _1i4qfg65 _1nmz1hna",
  headingWrapper: "_kqswh2mm",
  hiddenIconWrapper: "_19pkv77o"
};
type AgentCreator = {
  type: 'CUSTOMER';
  name: string;
  profileLink: string;
  status?: 'active' | 'inactive' | 'closed' | string;
} | {
  type: 'SYSTEM';
} | {
  // THIRD_PARTY is deprecated in convo-ai, use FORGE instead
  type: 'THIRD_PARTY' | 'FORGE';
  name: string;
} | {
  type: 'OOTB';
};
export const getAgentCreator = ({
  creatorType,
  authoringTeam,
  userCreator,
  forgeCreator
}: {
  creatorType: string;
  authoringTeam?: {
    displayName: string;
    profileLink?: string;
  };
  userCreator?: {
    name: string;
    status?: string;
    profileLink?: string;
  };
  forgeCreator?: string;
}): AgentCreator | undefined => {
  if (creatorType === 'SYSTEM') {
    return {
      type: ('SYSTEM' as const)
    };
  }
  if (fg('rovo_agent_support_a2a_avatar') ? isForgeAgentByCreatorType((creatorType as AgentCreatorType)) : creatorType === 'FORGE' || creatorType === 'THIRD_PARTY' // THIRD_PARTY is deprecated in convo-ai, use FORGE instead
  ) {
    return {
      type: ('FORGE' as const),
      name: forgeCreator ?? ''
    };
  }
  if (creatorType === 'OOTB') {
    return {
      type: ('OOTB' as const)
    };
  }
  if (creatorType === 'CUSTOMER') {
    if (authoringTeam) {
      return {
        type: ('CUSTOMER' as const),
        name: authoringTeam.displayName,
        profileLink: authoringTeam.profileLink ?? ''
      };
    }
    if (!userCreator?.profileLink) {
      return undefined;
    }
    return {
      type: ('CUSTOMER' as const),
      name: userCreator.name,
      profileLink: userCreator.profileLink,
      status: userCreator.status
    };
  }
  return;
};
export const AgentProfileCreator = ({
  creator,
  onCreatorLinkClick,
  isLoading
}: {
  /**
   * Get this value from `getAgentCreator`
   */
  creator?: AgentCreator;
  isLoading: boolean;
  onCreatorLinkClick: () => void;
}): JSX.Element | null => {
  const {
    formatMessage
  } = useIntl();
  const getCreatorRender = () => {
    if (isLoading) {
      return formatMessage(messages.agentCreatedBy, {
        creatorNameWithLink: <Skeleton testId="agent-profile-creator-skeleton" isShimmering height={18} width={100} />
      });
    }
    if (!creator) {
      return null;
    }
    if (creator.type === 'SYSTEM' || creator.type === 'OOTB') {
      return formatMessage(messages.agentCreatedBy, {
        creatorNameWithLink: <Inline alignBlock="center" testId="atlassian-icon">
						<AtlassianIcon label="" size="small" appearance="brand" />
						<Box>Atlassian</Box>
					</Inline>
      });
    }
    if (creator.type === 'CUSTOMER') {
      return formatMessage(messages.agentCreatedBy, {
        creatorNameWithLink: <Link href={creator.profileLink} onClick={() => onCreatorLinkClick()} target="_blank">
						{creator.name}{' '}
						{creator.status === 'inactive' && formatMessage(messages.agentDeactivated)}
					</Link>
      });
    }

    // THIRD_PARTY is deprecated in convo-ai, use FORGE instead
    if (creator.type === 'THIRD_PARTY' || creator.type === 'FORGE') {
      return formatMessage(messages.agentCreatedBy, {
        creatorNameWithLink: creator.name
      });
    }
    return null;
  };
  const creatorRender = getCreatorRender();
  return creatorRender ? <Box xcss={styles.clickableItem}>
			<Box xcss={styles.rovoIconWrapper} testId="rovo-icon-wrapper" aria-hidden="true">
				<RovoIcon appearance="brand" size="small" />
			</Box>
			{creatorRender}
		</Box> : null;
};
export const AgentProfileInfo = ({
  agentName,
  agentDescription,
  creatorRender,
  starCountRender,
  headingRender,
  isStarred,
  isHidden,
  onStarToggle,
  showStarButton = true,
  renderAdditionalContent
}: {
  agentName: string;
  agentDescription?: string | null;
  creatorRender: React.ReactNode;
  starCountRender: React.ReactNode;
  headingRender?: React.ReactNode;
  isStarred: boolean;
  isHidden: boolean;
  onStarToggle: () => void;
  showStarButton?: boolean;
  renderAdditionalContent?: () => React.ReactNode;
}): JSX.Element => {
  const {
    formatMessage
  } = useIntl();
  return <Stack space="space.100">
			<Inline xcss={styles.name} space="space.100" alignBlock="center">
				<Inline space="space.075" xcss={styles.headingWrapper}>
					<Heading as="h2" size="medium">
						{agentName}
					</Heading>
					{headingRender}
					{isHidden && <Box xcss={styles.hiddenIconWrapper}>
							<Tooltip content={formatMessage(messages.hiddenTooltip)} position="top">
								<HiddenIcon label={formatMessage(messages.hiddenIcon)} />
							</Tooltip>
						</Box>}
				</Inline>
				{showStarButton && <StarIconButton isStarred={isStarred} handleToggle={onStarToggle} agentName={agentName} />}
			</Inline>
			{creatorRender}
			{!!agentDescription && <Box xcss={styles.description} as="p">
					{agentDescription}
				</Box>}
			{starCountRender}
			{!!renderAdditionalContent && fg('jira_browse_agents_modal') && renderAdditionalContent()}
		</Stack>;
};